import ToggleButton from "@/components/shared/ToggleButton";
import AmountInput from "@/components/shared/AmountInput";

const SavingsRow = ({ icon: Icon, label, saving, onUpdate, index }) => {
  const handleToggle = (isMonthly) => onUpdate(index, { ...saving, is_monthly: isMonthly });
  const handleAmountChange = (value) => {
    if (saving.is_monthly) {
      onUpdate(index, { ...saving, monthly_amount: value, yearly_amount: value * 12 });
    } else {
      onUpdate(index, { ...saving, yearly_amount: value, monthly_amount: value / 12 });
    }
  };

  return (
    <div className="flex items-center justify-between py-4 row-divider savings-row-mobile" data-testid={`savings-row-${index}`}>
      <div className="flex items-center gap-2 sm:gap-3 shrink-0">
        <div className="category-icon"><Icon size={18} /></div>
        <span className="font-medium text-gray-700 text-sm sm:text-base">{label}</span>
      </div>
      <div className="flex items-center gap-2 sm:gap-4 row-controls">
        <ToggleButton isMonthly={saving.is_monthly} onToggle={handleToggle} dataTestId={`savings-toggle-${index}`} />
        <AmountInput value={saving.is_monthly ? saving.monthly_amount : saving.yearly_amount} onChange={handleAmountChange} dataTestId={`savings-amount-${index}`} />
      </div>
    </div>
  );
};

export default SavingsRow;
